<svg class="logo logo--login" viewBox="0 0 111 39.96">
  <use xlink:href="#ab-logo"></use>
</svg>

<form #forgotPasswordForm="ngForm" id="forgotPasswordForm" class="form form--auth" (ngSubmit)="onSubmit()">
  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <div class="mb-0150 auth-card mat-card--simple mat-card--border">
    <div class="auth-card__header">
      <h1 class="auth-card__title">Reset Password</h1>
      <p class="auth-card__subtitle">We’ll email a link to reset your password.</p>
    </div>

    <div class="auth-card__content">
      <mat-form-field [hideRequiredMarker]="true" class="col__ ongray mb-0">
        <mat-label>Email Address</mat-label>
        <input matInput id="email" name="email" type="email"
          [(ngModel)]="resetPasswordData.login"
          data-test-id="email"
          required autofocus/>
      </mat-form-field>
    </div>
  </div>

  <div class="mb-0100">
    <button type="submit"data-test-id="submitForgotPasswordButton"
      class="btn btn--full btn--lg"
      [disabled]="!forgotPasswordForm.valid">Send Reset Request
    </button>
  </div>

  <div class="center">
    <a routerLink="/login" class="auth-back-btn">
      Back to Login
    </a>
  </div>
</form>
